import axios from "axios";
import { backend } from "../config/backend";

const API = axios.create({ baseURL: backend.urlEndPoint });

API.interceptors.request.use((req) => {
	if (localStorage.getItem("profile")) {
		req.headers.authorization = `Bearer ${localStorage.getItem("profile").token}`;
	}
	return req;
});

export const agentRequestWithdrawal = async (token, cryptoCurrency, network, address, amount, currency, maxSet) => {
	return await API.post(
		"/admin/withdrawal/agentrequestwithdrawal",
		{
			token,
			cryptoCurrency,
			network,
			address,
			amount,
			currency,
			maxSet,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getWithdrawals = async (token, id, type) => {
	return await API.post(
		"/admin/withdrawals/getwithdrawals",
		{
			token,
			id,
			type,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getWithdrawalsPending = async (token, id) => {
	return await API.post(
		"/admin/withdrawals/getwithdrawalspending",
		{
			token,
			id,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const processWithdrawalResponse = async (token, id, accept) => {
	return await API.post(
		"/admin/withdrawals/processwithdrawalresponse",
		{
			token,
			id,
			accept,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};
